export var version = '3.7.7';
//# sourceMappingURL=version.js.map